import React from 'react'

import { TasksListContainer } from '@/components/containers/tasks/TasksListContainer'

const TasksPage: React.FC = () => <TasksListContainer />

export default TasksPage
